import React, { Component } from "react";
import makeAnimated from "react-select/animated";
import MySelect from "./MySelect.js";
import { components } from "react-select";
import { connect } from "react-redux";
// import { setDataArray } from "../../../../redux/actions/dataActions.js";
const Option = (props) => {
  return (
    <div className="mt-1">
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />
        <label className="mx-2">{props.label}</label>
      </components.Option>
    </div>
  );
};

const MultiValue = (props) => (
  <components.MultiValue {...props}>
    <span>{props.data.label}</span>
  </components.MultiValue>
);

const animatedComponents = makeAnimated();
class Example extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionSelected: null,
    };
  }

  handleChange = (selected) => {
    this.setState({
      optionSelected: selected,
    });
  };

  render() {
    const { slistDropdown, selectedData } = this.props;
    //console.log("slistDropdown", slistDropdown);
    // this.props.setDataArray(this.state.optionSelected);
    // console.log(this.state.optionSelected);
    // console.log("selectedData555", selectedData);
    return (
      <>
        <MySelect
          options={slistDropdown}
          selectedData={selectedData} //useless
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{ Option, MultiValue, animatedComponents }}
          onChange={this.handleChange}
          allowSelectAll={true}
          value={this.state.optionSelected}
          placeholder="Select students"
          // styles={customStyles}
        />
      </>
    );
  }
}
const mapDispatchToProps = {};
export default connect(null, mapDispatchToProps)(Example);
